export function replaceOrganizationTreeBranch(currentOrganization, newChildren, parentId) {
    return currentOrganization.map((organization) => {
        if (organization.id === parentId) {
            return Object.assign(Object.assign({}, organization), { children: newChildren });
        }
        return Object.assign(Object.assign({}, organization), { children: organization.children ? replaceOrganizationTreeBranch(organization.children, newChildren, parentId) : [] });
    });
}
